import moment from 'moment-timezone'

const filters = {
  date_format (val) {
    return moment(val).format('DD MMMM, YYYY')
  },
  date_time_format (val) {
    return moment(val).format('ddd, MMM Do YYYY, h:mma')
  },
  detail_date_time_format (val) {
    return moment(val).format('dddd Do of MMMM YYYY hh:mm A')
  },
  short_date_time_format (val, timezone) {
    if (timezone) {
      return moment(val).tz(timezone).format('ddd DD MMM, h:mma')
    } else {
      return moment(val).format('ddd DD MMM, h:mma')
    }
  },
  time_format (val) {
    if (!val) return 'No Time Set'
    return moment(val).tz('Australia/Melbourne').format('h:mm a')
  },
  short_date_format (val) {
    if (!val) return 'No Date Set'
    return moment(val).tz('Australia/Melbourne').format('DD/MM/YYYY')
  },
  short_date_format_day (val) {
    if (!val) return 'No Date Set'
    return moment(val).tz('Australia/Melbourne').format('ddd DD/MM/YYYY')
  },
  toDollarAmount (val) {
    if (!val || val < 0) return '$0.00'
    if (isNaN(Number(val))) return val
    var number = Number(Math.round(val + 'e2') + 'e-2').toFixed(2)
    if (number.length < 6) return '$' + number
    var mod = (number.length) % 3
    var formatted = number.substr(mod, number.length).replace(new RegExp(/(\d{3})(?=\d)/, 'gi'), '$1,')
    if (mod !== 0) formatted = ',' + formatted
    return '$' + number.substr(0, mod) + formatted
  },
  to_dollar_amount_neg (val) {
    if (!val) return '$0.00'
    if (isNaN(val)) return val
    var number = Number(Math.round(Math.abs(val) + 'e2') + 'e-2').toFixed(2)
    if (number.length < 6) {
      if (val < 0) return '-$' + number
      else return '$' + number
    }
    var mod = (number.length) % 3
    var formatted = number.substr(mod, number.length).replace(new RegExp(/(\d{3})(?=\d)/, 'gi'), '$1,')
    if (mod !== 0) formatted = ',' + formatted
    if (val < 0) return '-$' + number.substr(0, mod) + formatted
    else return '$' + number.substr(0, mod) + formatted
  },
  stripe_currency (val) {
    if (!val || val < 0) return '$0.00'
    var number = (Number(Math.round(val + 'e2') + 'e-2') / 100).toFixed(2)
    if (number.length < 6) {
      if (val < 0) return '-$' + number
      else return '$' + number
    }
    var mod = (number.length) % 3
    var formatted = number.substr(mod, number.length).replace(new RegExp(/(\d{3})(?=\d)/, 'gi'), '$1,')
    if (mod !== 0) formatted = ',' + formatted
    if (val < 0) return '-$' + number.substr(0, mod) + formatted
    else return '$' + number.substr(0, mod) + formatted
  },
  to_calendar_time (val) {
    let xm = 'AM'
    if (val >= 12) {
      val = val - 12
      xm = 'PM'
      if (val >= 24) xm = 'AM'
    }
    if (val === 0) val = 12
    return `${val}${xm}`
  },
  nl2br (val) {
    // Next line to Break
    return (val + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2')
  }
}
module.exports = filters



// WEBPACK FOOTER //
// ./src/util/filters.js